// extracted by mini-css-extract-plugin
export default {"skeleton":"RecordEntrySkeleton_skeleton__ld9IP","shine":"RecordEntrySkeleton_shine__3Q1sO"};